export default {
  login_register: 'Најави се/Регистрирај се',
  booking_confirmation_title: 'Потврда за резервација',
  booking_confirmation_body: 'Ви благодариме за вашата резервација. Ве молиме најдете детали за потврда подолу.',
  insurance_requirements_modal_disclaimer: `Со извршување на оваа резервација, јас потврдувам дека: Немам казни или саботувања во сообраќајот во последните
    5 години. Немам одбиена понуда за застапување, откажана полиса или одбиена реновација или ми е било наложено
    да платам зголемена премија или ми биле наметнати специфични услови од некој осигурувач. Немам лиценца
    за возење откажана. Немам текуќа казна или истрага од полиција. Немам казни за кражба, превара или нечесни дејства
    во последните 5 години. Немам проблеми со вид или слух (кои не се исправуваат со наочари или слушалка), срцеви болести,
    дијабетес, епилепсија или било каква физичка или ментална неспособност од каков било вид. Немам имало
    незгоди во последните 5 години. Ве молиме кликнете {0} ако не ги исполнувате овие барања`,
  insurance_requirements_here: 'тука',
  insurance_requirements: 'Ги прочитав и разбрав {0}',
  ir: 'Барања за осигурување',
  location: 'Локација',
  pickup_location: 'Локација за подигнување',
  dropoff_location: 'Локација за враќање',
  vehicle: 'Возило',
  pickup_and_dropoff: 'Подигнување и враќање (локално време)',
  view_voucher: 'Прегледај Ваучер',
  identity_verification_body: 'Ќе бидете задолжени да го верификувате вашиот идентитет пред да го земете возилото',
  identity_verification_title: 'Верификација на идентитет',
  search_again: 'Пребарај повторно',
  refrigerated: 'рефрижериран',
  aircon_lower: 'клима',
  aircon: 'Клима',
  refrigeration: 'Рефрижерација',
  not_available: 'Drive & Go во моментов е достапен само за лица со идентитет и возачка дозвола од следниве земји.',
  check_if_included: 'Проверете дали вашата земја е вклучена.',
  included_in_booking: 'Вклучено во оваа резервација',
  cdw_with_excess: 'CDW со дополнителен износ',
  theft_protection: 'Заштита од кражба со дополнителен износ',
  risk_reduction: 'Намалување на ризик',
  free_extras: 'Имате право на две бесплатни додатоци <br /> со оваа резервација.',
  continue: 'Продолжи',
  luggage_large_short_label: 'Г',
  luggage_medium_short_label: 'С',
  luggage_small_short_label: 'М',
  luggage_large_long_label: 'големи',
  luggage_medium_long_label: 'средни',
  luggage_small_long_label: 'мали',
  fuel_unspecified_label: 'ненаведено',
  transmission_manual_label: 'Рачен',
  transmission_automatic_label: 'Автоматски',
  make_a_booking: 'Изврши резервација',
  pickup_date: 'Датум на подигање',
  dropoff_date: 'Датум на враќање',
  driver_age: 'Возач помеѓу 30 - 65 години',
  enter_driver_age: 'Ве молиме внесете го возачкиот возраст',
  promo_code: 'Промотивен код',
  search: 'Пребарај',
  dropoff_date_cannot_be_before_pickup_date: 'Датумот на враќање не може да биде пред датумот на подигање',
  pickup_date_cannot_be_in_the_past: 'Датумот на подигање не може да биде во историјата',
  pickup_time_cannot_be_in_the_past: 'Времето на подигање не може да биде во историјата',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Времето на враќање мора да биде подоцна од времето на подигање ако се во ист ден',
  vehicle_filters: 'Филтри на возила',
  reset: 'Ресетирај',
  transmission: 'Пренос',
  all: 'Сите',
  manual: 'Рачен',
  auto: 'Автоматски',
  passengers: 'Патници',
  vehicle_type: 'Тип на возило',
  filter: 'Филтер',
  vehicle_search: 'Пребарување на возила',
  edit: 'Уреди',
  no_results: 'Нема резултати кои одговараат на вашите филтер критериуми.',
  small_cars: 'Мали автомобили',
  medium_cars: 'Средни автомобили',
  large_cars: 'Големи автомобили',
  estate_cars: 'Станични автомобили',
  suvs: 'СУВ-ови',
  mpvs: 'МПВ-ови',
  vans: 'Фургони',
  camper_vans: 'Кемпер фургони',
  premium: 'Премиум',
  unspecified: 'ненаведено',
  large: 'големи',
  medium: 'средни',
  small: 'мали',
  automatic: 'автоматски',
  you_have_been_refunded: 'Ви е направена враќачка на средства.',
  please_customer_service: 'За да направите резервација, ве молиме контактирајте го нашиот купечки сервис.',
  contact_customer_service: 'Контактирајте го купечкиот сервис',
  booking_failed: 'Вашата резервација не можеше да се обработи во моментов.',
  summary: 'Содржина',
  reforestation_and_protection: 'Поддршка за афорестација и заштита на регенскиот шум во цела Костарика',
  cost_of_rental: 'Цена на изнајмување',
  to_pay_now: 'За плаќање сега',
  greenheart_donation: 'Донација на Зелено срце',
  total_cost: 'Вкупна цена на изнајмувањето',
  tc_agreement: 'Ги прочитав и разбрав {0}.',
  tc: 'УС',
  receive_offers: 'Сакам да добивам посебни понуди по е-пошта.',
  donate: 'Да, сакам да донирам {износ}',
  pay_now: 'Плати {износ} сега',
  driver_details: 'Детали за возачот',
  complete_driver_details: 'Ве молиме, дополнете ги деталите за возачот.',
  are_you_the_driver: 'Дали сте возачот?',
  have_an_account: 'Имате ли веќе профил?',
  login: 'Најава',
  or: 'или',
  first_name: 'Име на возачот',
  last_name: 'Презиме на возачот',
  email: 'Адреса за е-пошта',
  phone_number: 'Мобилен телефонски број',
  unable_to_save_driver_information: 'Не можеме да ги зачуваме информациите за возачот. Ве молиме обидете се повторно.',
  pay_online_now: 'Плати сега онлајн',
  day: 'Ден',
  choose_location: 'Изберете локација',
  location_not_found: 'Извинете, не можевме да ја најдеме локацијата која ја барате.',
  add: 'Додади',
  remove: 'Отстрани',
  free_extra: 'Бесплатен додаток',
  free: 'БЕСПЛАТНО!',
  fast_track_notice: 'Забелешка: За оваа услуга се аплицираат ограничувања на потекло на документи. Таа е достапна само за лица со документи од',
  complete_booking: 'Заврши резервација',
  choose_card: 'Ве молиме изберете карта или додадете нова.',
  add_billing_details: 'Ве молиме додадете ги деталите за наплата.',
  card_number: 'Број на карта',
  card_holder_name: 'Име на држач на картата',
  card_exp: 'MM / GG',
  card_cvc: 'CVC',
  save_card: 'Зачувај карта?',
  amount_charged: 'Вашата карта ќе биде наплатена',
  payment_confirmation: 'Потврдете резервација и плаќање',
  payment_methods: 'достапни методи за плаќање',
  use_saved_card: 'x користете зачувана карта',
  use_different_card: '+ користете различна карта',
  book_now: 'Резервирај сега',
  minimum_age: 'Само за лица над {age} години',
  excess_liability: 'Одговорност за излишок',
  security_deposit: 'Депозит за безбедност',
  fuel_policy: 'Политика на гориво',
  like_for_like: 'Слично за слично',
  full_to_full: 'Полн резервоар при подигање и полн резервоар при враќање',
  miles_per_rental: '{mileage} бесплатни мили по изнајмување',
  km_per_rental: '{mileage} бесплатни километри по изнајмување',
  unlimited_mileage: 'Неограничени мили',
  unlimited_mileage_km: 'Неограничени километри',
  non_amendable: 'Не се може изменување',
  non_refundable: 'Не се враќа',
  free_cancellation_until: 'Бесплатно откажување до',
  cancellation_in_line_with: 'Откажување во согласност со',
  tcs: 'УС',
  free_extras_on_collection: 'Два бесплатни допатници при подигање',
  glass_and_tyres_covered: 'Покриени стакло и гуми',
  number_of_passengers: 'Број на патници',
  number_of_bags: 'Број на багажи',
  fuel_type: 'Тип на гориво',
  co2: 'CO2',
  book_type: 'Резервирај {type}',
  processing: 'Процесирање',
  actual_price: 'Актуелна цена',
  tooltip: 'Цената во {currencyCode} е проценка заснована на курс на размена, цената во {currency} е заврзана.',
  pay_online: 'Плати онлајн сега',
  pay_online_without_extras: 'Цена за изнајмување',
  extras_on_arrival: 'Допатници при пристигнување',
  insurance_on_arrival: 'Намалување на ризик - Плаќање при пристигнување',
  insurance_online: 'Намалување на ризик - Плаќање сега',
  extras_online: 'Допатници - Плаќање сега',
  green_heart_donation: 'Донација на Зелено срце',
  why_use_drive_and_go: 'Зошто користит Drive & Go?',
  straight_to_car: 'Директно до автомобилот',
  no_queues: 'Нема редови',
  self_checkout: 'Самостоен излез',
  cant_lose_key: 'Не може да се загуби клучот',
  online_id_check: 'Онлајн проверка на идентитет',
  phone_as_key: 'Телефон како клуч',
  premiumplus_benefits_includes: 'Премиум Плус+ предности исто така се вклучени',
  book_drive_go: 'Резервирајте Drive & Go',
  distance_allowance: 'Дозвола за растојание',
  duration: 'Времетраење',
  view_more_bookings: 'Прикажи повеќе резервации',
  to_pay_on_arrival: 'Плаќање при пристигнување',
  pay_on_arrival: 'Плати при пристигнување',
  unlimited: 'Неограничено',
  return_date: 'Датум на враќање',
  postcode: 'Поштенски број',
  country: 'Земја',
  drive_and_go: {
    drive_and_go: 'Drive And Go',
    available_countries: 'Drive & Go е моментално достапен само за лица со идентификациони документи и дозволи за возење од следниве земји:',
    drive_and_go_today: 'Резервирајте Drive & Go денес!',
    drive_and_go_shortened: 'Drive & Go',
    why_use_drive_and_go: 'Зошто да го користите Drive & Go?',
    straight_to_car: 'Директно до автомобилот',
    no_queues: 'Без редови',
    self_checkout: 'Самопреглед',
    cannot_lose_the_key: 'Не може да се загуби клучот',
    online_id_check: 'Онлајн проверка на идентитет',
    phone_as_a_key: 'Телефон како клуч',
    premium_plus_benefits_also_included: 'Премиум Плус+ предности исто така се вклучени',
    book_drive_and_go: 'Резервирајте Drive & Go'
  },
  my_bookings: 'Мои резервации',
  no_bookings: 'Нема резервации',
  my_profile: 'Мој Профил',
  no_bookings_to_display: 'Нема резервации за прикажување.',
  search_great_car_rental_deals: 'Пребарајте одлични понуди за изнајмување на автомобили за вашата следна патување.',
  odometer_at_collection: 'Одометар при подигање',
  fuel_at_collection: 'Гориво при подигање',
  start_check_in: 'Започнете со проверка',
  start_collection: 'Започнете со подигање',
  recent_bookings: 'Најнови резервации',
  damage: {
    updated_damage_report_submitted: 'Поднесен е ажуриран извештај за штета. Член на нашиот купечки сервис ќе се јави ако е потребно.',
    add_additional_damage: 'Додадете дополнителна штета',
    you_may_report_additional_damage_up_to: 'Можете да пријавите дополнителна штета до 24 часа по проверката на возилото',
    specify_damage: 'Специфицирајте ја штетата',
    please_choose_the_area_and_type_of_damage: 'Изберете го регионот и видот на штета',
    type_of_damage: 'Вид на штета',
    is_this_more_than_5_cm: 'Дали ова е повеќе од 5 цм?',
    please_take_or_select_a_photo: 'Ве молиме направете или изберете слика',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Ве молиме направете слика обезбедувајќи дека штетата е јасно видлива',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: 'Доколку ви треба, можете да додадете уште една слика - изберете го иконата за додавање на уште една слика',
    save_image: 'Зачувај слика',
    save_images: 'Зачувај слики',
    damage_saved_successfully: 'Штетата успешно зачувана',
    add_photo: 'Додадете слика'
  },
  checkout: {
    start_collection: 'Започнете со подигање',
    collect_vehicle: 'Подигање на возилото',
    we_will_let_you_know_the_details: 'Ќе ви ги информираме за локацијата и деталите за да го најдете изнајменото возило.',
    inspect: 'Проверете',
    we_will_ask_for_four_photos_from_each_corner: 'Ќе ви бараат четири слики од секој агол на возилото заедно со било која нова штета која веќе не е наведена.',
    fuel_and_milage: 'Гориво и километри',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Ги потврдувате одометар и гориво на почетокот на изнајмувањето.',
    sign: 'Потпишете',
    sign_the_rental_agreement: 'Потпишете го договорот за изнајмување.',
    away_you_go: 'Оди и патувајте',
    you_are_free_to_take_to_the_road: 'Слободно можете да тргнете на пат!',
    collect_your_vehicle: 'Подигнете го вашиот автомобил',
    get_directions: 'Потрудете се до локацијата',
    hide_directions: 'Сокријте ги насоките',
    local_time: 'локално време',
    tel: 'Телефон',
    getting_to_the_location: 'Достигнување на локацијата',
    get_vehicle_details: 'Детали за возилото',
    view_map: 'Погледнете го мапата',
    unlock_vehicle_and_continue: 'Отклучете го возилото и продолжете',
    unable_to_connect_to_vehicle: 'Не може да се поврзете со возилото',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'Не можеме да се поврземе со возилото - ве молиме проверете дали сте до правилниот автомобил и обидете се повторно.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Не можеме да го најдеме резервирањето на возилото. Ве молиме обидете се повторно подоцна.',
    odometer_and_fuel: 'Одометар и гориво',
    odometer: 'Одометар',
    please_confirm_the_odometer_and_fuel_readings: 'Ве молиме потврдете ги одометарот и горивото',
    the_odometer_field_is_required: 'Полето за одометар е задолжително',
    and_must_be_greater_than_the_checkout_odometer: 'и мора да биде поголемо од одометарот при проверката',
    confirm: 'Потврдете',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Ве молиме направете слика од секој агол на возилото',
    pre_existing_damage: 'Постоечка штета',
    no_pre_existing_damage: 'Нема постоечка штета.',
    new_damage: 'Нова штета',
    add_additional_damage: 'додадете дополнителна штета',
    no_new_damage_to_report: 'Нема нова штета за пријавување',
    checkout_complete: 'Проверката завршена',
    start_rental: 'Почеток на изнајмување',
    congratulations_name_it_is_time_to_take_to_the_road: 'Честитки, {customer_name}, време е да тргнете на пат!',
    we_are_unable_to_complete_your_vehicle_checkout: 'Не можеме да ја завршиме проверката на вашиот автомобил.',
    please_do_the_following: 'Ве молиме направете го следното',
    remove_all_belonging_and_lock_the_vehicle: 'Извадете ги сите ствари и заклучете го возилото.',
    lock_vehicle: 'Заклучете го возилото',
    once_you_have_contacted_customer_services: 'Откако ќе контактирате со купечкиот сервис',
    vehicle_location: 'Локација на возилото',
    collect_your: 'Подигнете го вашиот',
    from: 'Од',
    key_in_glove_box: 'вашите клучеви се наоѓаат во преглувалник',

    keyholder: {
      not_detected: 'Клучот не е откриен во преглувалник',
      not_detected_please_try_again: 'Ве молиме ставете го клучот во преглувалникот и обидете се повторно.',

      not_installed: 'Преглувалникот не е инсталиран',
      not_installed_please_contact_customer_service: 'Преглувалникот не е инсталиран, ве молиме контактирајте со купечкиот сервис.',
    },
    keyring: {
      look_up_failed: 'Неуспешно барање на преглувалник',
      look_up_failed_please_contact_customer_service: 'Неуспешно барање на преглувалник, ве молиме контактирајте со купечкиот сервис.',
    },
    key: {
      invalid: 'Невалиден клуч',
      invalid_please_contact_customer_service: 'Вашиот клуч е невалиден, ве молиме контактирајте со купечкиот сервис.',

      expired: 'Истечен клуч',
      expired__please_contact_customer_service: 'Вашиот клуч истече, ве молиме контактирајте го сервисот за корисници.',
    }
  },
  checkin: {
    start_check_in: 'Почеток на проверката',
    vehicle_location: 'Локација на возилото',
    tell_us_where_you_have_parked: 'Кажете ни каде го паркиравте возилото.',
    fuel_and_milage: 'Гориво и милажа',
    you_confirm_the_readings_at_the_end_of_your_hire: 'Потврдете ги одометарските и горивните измерувања на крајот од изнајмувањето.',
    inspect: 'Инспекција',
    we_will_ask_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Ќе бараме четири слики од секој агол на возилото заедно со секаква нова штета настаната по време на изнајмувањето.',
    lock: 'Заклучи',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Проверете дали немате оставено ништо и потоа заклучете го возилото.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Ве молиме кажете ни каде го паркиравте возилото.',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Откако возилото ќе биде заклучено, немате да можете повторно да го отклучите.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, Ве молиме проверете дали немате оставено ништо, заклучете го возилото и, ако е потребно, вратете го физичкиот клуч на задржувачот на клучеви.',
    lock_vehicle: 'Заклучи го возилото',
    complete_check_in: 'Заврши ја проверката',
    inspection: 'Инспекција',
    complete_vehicle_check_in: 'Заврши ја проверката на возилото',
    we_are_unable_to_complete_your_vehicle_check_in: 'Не можеме да ја завршиме проверката на вашето возило.',
    please_contact_customer_services: 'Ве молиме контактирајте го сервисот за корисници',
    once_you_have_contacted_customer_services: 'Откако ќе контактирате со сервисот за корисници',
    please_amend_odometer_to_be_greater_than: 'Ве молиме поправете го одометарот да биде поголем од {odometer_value}',
  },
  rental_agreement: {
    rental_agreement: 'Договор за изнајмување',
    agreement_between: 'Договор меѓу',
    and: 'и',
    sign_rental_agreement: 'Потпишете го договорот за изнајмување',
    i_have_read_and_understood_the_terms_and_conditions: 'Ги прочитав и разбрав Условите и условите и ги прифатам условите за користење на возилото',
  },
  additional_options: 'Дополнителни опции',
  booking_details: 'Детали за резервација',
  price_for_x_days: 'Цена за {qty_of_days} ден | Цена за {qty_of_days} дена',
  cancelled: 'Откажано',
  upcoming: 'Предстојачки',
  active: 'Активно',
  full_insurance_no_deposit: 'Полно осигурување и без депозит',
  excess: 'Излишок од {amount}',
  deposit: 'Депозит од {amount}',
  included_daily_distance: '{distance} {unit} на ден',
  miles: 'мили',
  kilometers: 'километри',
  collection_details_title: 'Детали за подигнување',
  collection_details_not_found: 'Не се дефинирани детали за подигнување на оваа локација',
  free_cancellation: 'Бесплатно откажување',
  no_deposit: 'Без депозит',
  benefit_from: 'Искористете ги предностите на',
  for_only_per_day: 'Само за {price} на ден',
  upgrade_mee: 'ПодобрувањеMee'
}
